import { gql } from '@apollo/client';

export const UpdateDeliveryLineReceiverFieldsMutation = gql`
    mutation UpdateDeliveryLineReceiverFieldsMutation($input: DeliveryLineReceiverUpdateInput!) {
        deliveryLineUpdateReceiverFields(input: $input) {
            id
            receiverComment
            receiverCheck
        }
    }
`;

export const UpdateDeliveryLineBatchMutation = gql`
    mutation UpdateDeliveryLineBatch($lineId: String!, $batchId: String) {
        deliveryLineUpdateBatch(lineId: $lineId, batchId: $batchId) {
            id
            batchId
            batch {
                id
                name
            }
        }
    }
`;
